/** Parámetros de sede estables para listados Compras. */
export function appendComprasSiteParams(params, purchaseSiteId, withoutPurchaseSite) {
  if (withoutPurchaseSite) {
    params.without_purchase_site = 1;
  } else if (purchaseSiteId) {
    params.purchase_site_id = purchaseSiteId;
  }
  return params;
}
